module.exports = __webpack_public_path__ + "f968d7341853b1de5d9bd29fd288d94b.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/cloud.png
// module id = 19
// module chunks = 0